var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.open)?_c('section',{staticClass:"modal-root"},[_c('div',{staticClass:"modal-root__container",class:{ big: _vm.big }},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }